export const endpoints = {
  dashboardItem: 'dashboard',

  languageOptions: 'dashboard/language/options',

  accessTypeOptions: 'dashboard/accessType/options',

  caseTypeOptions: 'dashboard/caseType/options',
  userGroupOptions: 'dashboard/usergroup/options',
  personOptions: 'dashboard/person/options',

  filterDomains: 'report/filterDomains',

  filterFields: 'dashboard/field/options',
  filterMetadata: 'dashboard/field/metadata',

  codeOptionsFor: (domainId: number) => `dashboard/field/${domainId}/options`,
  categoryOptionsFor: (domainId: number) => `dashboard/field/${domainId}/categoryOptions`,
  periodPredefOptions: 'dashboard/period/options',
  dbFunction: 'dashboard/dbFunction/options'
};
